import React, { useEffect, useState } from 'react';
import '../styles/Message.css';

function Message({ text, duration = 4000 }) {
  const [show, setShow] = useState(false);

useEffect(() => {
  if (!text) return setShow(false);

  setShow(true);
  const timer = setTimeout(() => setShow(false), duration);
  return () => clearTimeout(timer);
}, [text, duration]);

if (!show) return null;

  return (
    <div className={`message ${show ? 'show' : ''}`}>
      {text}
    </div>
  );
}

export default Message;
